// Angular
import { Injectable } from '@angular/core';
// RxJS
import { BehaviorSubject } from 'rxjs';
// Object path
import * as objectPath from 'object-path';
// Services
import { MenuConfigService } from './menu-config.service';


import {HttpClient}from '@angular/common/http';
import {environment} from '../../../../../environments/environment';

@Injectable()
export class MenuAsideService {
	// Public properties
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
	selectedModuleId$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);

	/**
	 * Service constructor
	 *
	 * @param menuConfigService: MenuConfigService
	 */
	constructor(private menuConfigService: MenuConfigService,private http:HttpClient) {
		this.loadMenu();
	}

	// baseUrl: string='http://localhost:50962/api/ADM0000/';
	baseUrl: string=environment.baseUrl+'ADM0000/';
	

	/**
	 * Load menu list
	 */
	loadMenu() {
	
		this.menuList$.next(null);
	//	var ModuleId = localStorage.getItem('ModuleId');

	    var ModuleId ='0';
		if(localStorage.getItem('ModuleId')!=null && localStorage.getItem('ModuleId')!=undefined && localStorage.getItem('ModuleId')!='')
		{
			ModuleId=localStorage.getItem('ModuleId') || '0';
		}

		this.http.get<any>(this.baseUrl+'GetMenu/' + ModuleId).subscribe(data=>{

		

		// 	var datas=data;

		// 	var menudata=objectPath.get(this.menuConfigService.getMenus(), 'aside.items');


		// const	items:any[]= [
			
				
		// 		//{section: 'Applications'},
				
		// 		{
		// 			title: 'User Management',
		// 			root: true,
		// 			bullet: 'dot',
		// 			icon: 'flaticon2-user-outline-symbol',
		// 			submenu: [
		// 				{
		// 					title: 'Users12',
		// 					page: '/user-management/users'
		// 				},
		// 				{
		// 					title: 'Roles12',
		// 					page: '/user-management/roles'
		// 				}
		// 			]
		// 		},

		// 	//	{section: 'Applications'},
				
		// 		{
		// 			title: 'User Management123',
		// 			root: true,
		// 			bullet: 'dot',
		// 			icon: 'flaticon2-user-outline-symbol',
		// 			submenu: [
		// 				{
		// 					title: 'Users12',
		// 					page: '/user-management/users'
		// 				},
		// 				{
		// 					title: 'Roles12',
		// 					page: '/user-management/roles'
		// 				}
		// 			]
		// 		}];


			// const menuItems: any[] = items;
			const menuItems: any[] = data;
		this.menuList$.next(menuItems);
		})
	
		// get menu list
		// const menuItems: any[] = objectPath.get(this.menuConfigService.getMenus(), 'aside.items');
		// this.menuList$.next(menuItems);
	}


	setSelectedModuleId(moduleId: number | null) {
			if (moduleId != null) {
			localStorage.setItem('ModuleId', moduleId.toString());

		  }
		// else {
		// 			}
		// if (moduleId === null) {
		// 	localStorage.removeItem('ModuleId');
		// } else {
		// 	localStorage.setItem('ModuleId', moduleId.toString());
		// }
		this.selectedModuleId$.next(moduleId);
	}

	getSelectedModuleId(): number | null {
		const moduleId = localStorage.getItem('ModuleId');
		return moduleId ? parseInt(moduleId, 10) : null;
	}

	loadMenuULMenu() {
		var ModuleId = localStorage.getItem('ModuleId');
		return this.http.get<any>(this.baseUrl+'GetMenu/' + ModuleId);
		// this.http.get<any>(this.baseUrl+'GetMenu/' + ModuleId).subscribe(data=>{
		// 	const menuItems: any[] = data;
		// })

	}
}
